import React from 'react';
import { array, object } from 'prop-types';
import I18nProvider from '@fiverr-private/fiverr_context/src/I18nProvider';
import PackageCalculator from '../../shared/PackageCalculator';
import { BASIC_PACKAGE_ID, PREMIUM_PACKAGE_ID, STANDARD_PACKAGE_ID } from '../../../utils/packagesUtils/constants';
import { findCalculatorByPackageId } from '../../../utils/calculator';
import { getFormattedLabel } from '../../../utils/translation/pricingFactors/label';

import './style.scss';

const prepareCalc = (calculatorRowData) => ({
    basicCalc: findCalculatorByPackageId(calculatorRowData, BASIC_PACKAGE_ID),
    standardCalc: findCalculatorByPackageId(calculatorRowData, STANDARD_PACKAGE_ID),
    premiumCalc: findCalculatorByPackageId(calculatorRowData, PREMIUM_PACKAGE_ID)
});

const CalculatorRow = ({ calculatorRowData = [] }, { general: { subCategoryId } }) => {
    if (calculatorRowData.length !== 3) {
        return null;
    }

    const getCalculatorFormattedLabel = (i18n, calculator) => {
        const { name, type, value } = calculator;

        return getFormattedLabel(i18n, name, type, value, subCategoryId);
    };

    const { basicCalc, standardCalc, premiumCalc } = prepareCalc(calculatorRowData);
    const calculatorArray = [premiumCalc, standardCalc, basicCalc];

    return (
        <tr className="calculator-row">
            <I18nProvider>
                {({ i18n }) => (
                    <th>{getCalculatorFormattedLabel(i18n, basicCalc)}</th>
                )}
            </I18nProvider>
            {
                calculatorArray.map((calculator) => (
                    <td key={calculator.packageId}>
                        <PackageCalculator {...calculator}/>
                    </td>
                ))
            }
        </tr>
    );
};

CalculatorRow.propTypes = {
    calculatorRowData: array
};

CalculatorRow.contextTypes = {
    general: object
};

export default CalculatorRow;
